module.exports = __webpack_public_path__ + "img/bg_product_01@2x.0632f342.png";